<template>
  <div class="c-productImageBlock" :style="{backgroundColor: content.bgColor}">
    <div :class="content.className">
      <div class="c-productImageBlock__title">
        <h3 class="title_h3" v-show="content.title">{{ content.title }}</h3>
      </div>
      <div class="c-productImageBlock__content">
        <div class="relative">
          <img :src="content.image" alt="">
          <p class="absolute" v-if="content.imageCoord" v-for="(t, r) in content.imageCoord" :style="{bottom: t.y, left: t.x}">{{ t.content }}</p>
        </div>
        <div>
          <div class="c-productImageBlock__block" v-for="(n, i) in content.content" :key="i">
            <h4 v-if="n.type=='title'" class="title_h4">{{ n.content }}</h4>
            <p v-if="n.type=='text'" class="c-productImageBlock__text">{{ n.content }}</p>
            <ul v-else-if="n.type=='list'" class="c-productImageBlock__list">
              <li v-for='(x, y) in n.content' :key='y'>{{ x }}</li>
            </ul>
            <span v-else-if="n.type=='smallText'">{{ n.content }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'productImageBlock',
    props: ['content'],
    data(){
      return{

      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
